import Model from '@/app/Model'

export class Thumbnail extends Model {
	static fields () {
		return {
			id: null,
			url: null
		}
	}
	static hasMany () {
		return {}
	}
}

export function createPicture (data) {
	return Object.freeze(new Thumbnail(data))
}
